<template>
  <div class="course-volunteers">
    <ag-table :data-source-api="getAllCourseVolunteers" :grid-options="gridOptions" :permissions="permissions"
      :rtl="false" :is-entities-response="false" />
  </div>
</template>

<script>
import utilities from "@/app/shared/utilities/index";
import { RepositoryFactory } from '../../volunteer-repositories/volunteerRepositoryFactory';
import AgTable from '../../../shared/shared-components/ag-grid/AgTableServerSide.vue';

const coursesRepo = RepositoryFactory.get('coursesRepository');

export default {
  name: "CourseVolunteers",
  components: {
    AgTable,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      isActiveMap: {
        'true': 'نعم',
        'false': 'لا',
      },
      permissions: {},
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: 'معرف المتطوع',
          field: 'id',
          sortable: true,
          suppressSizeToFit: true,
          width: 200,
        },
        {
          headerName: 'الاسم',
          field: 'name',
          filter: 'agTextColumnFilter',
          width: 210,
          sortable: false,
        },
        {
          headerName: 'رقم الموبايل',
          field: 'phoneNumber',
          filter: 'agTextColumnFilter',
          width: 210,
          sortable: false,
        },
        {
          headerName: 'رقم البطاقة',
          field: 'cardNumber',
          filter: 'agTextColumnFilter',
          width: 210,
          sortable: false,
        },
        {
          headerName: 'فعّال',
          field: 'isActive',
          width: 210,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.isActive ? 'نعم' : 'لا';
          },
          filter: 'agSetColumnFilter',
          filterParams: {
            values: Object.keys(self.isActiveMap),
            valueFormatter: params => {
              return self.isActiveMap[params.value];
            }
          }
        },
        {
          headerName: 'تاريخ الإسناد',
          field: 'trainingCourseVolunteers',
          width: 200,
          sortable: false,
          valueGetter: function getObject(params) {
            const trainingCourseVolunteer = (params.data.trainingCourseVolunteers || [])[0];
            return trainingCourseVolunteer ? utilities.formatDate(trainingCourseVolunteer.createdAt, "yyyy-MM-DD") : '-';
          },
        },
      ];
    },
    async getAllCourseVolunteers(query) {
      const id = this.$route.params.id;
      return await coursesRepo.getCourseVolunteers(id, query);
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
};
</script>
